"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontTypeMediaQueryMixin = void 0;
var _fontTypeIconAlignmentMixin = require("./fontTypeIconAlignmentMixin");
var _fontTypeMixin = require("./fontTypeMixin");
var _mediaQueryMixin = require("./mediaQueryMixin");
/** @mixin fontTypeMediaQueryMixin */
/**
 * @method
 */
var fontTypeMediaQueryMixin = (0, _mediaQueryMixin.mediaQueryMixin)(function (mediaProps) {
  if (!('fontType' in mediaProps)) {
    return '';
  }
  return function (props) {
    return [(0, _fontTypeMixin.fontTypeMixin)(Object.assign({}, props, mediaProps)), (0, _fontTypeIconAlignmentMixin.fontTypeIconAlignmentMixin)(Object.assign({}, props, mediaProps))];
  };
});
exports.fontTypeMediaQueryMixin = fontTypeMediaQueryMixin;